export default from './BidRequestValueField';



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestInfo/components/BidRequestValueField/index.js